import React, { useState, useEffect } from 'react';
import { getServices, getServiceCategories } from '@/services/api';
import { getVehicles } from '@/services/vehicles';

const TestPage: React.FC = () => {
  const [services, setServices] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const testAPI = async () => {
      try {
        setLoading(true);
        setError('');
        
        console.log('Probando APIs...');
        
        // Probar servicios
        const servicesData = await getServices();
        console.log('Servicios:', servicesData);
        setServices(servicesData);
        
        // Probar categorías
        const categoriesData = await getServiceCategories();
        console.log('Categorías:', categoriesData);
        setCategories(categoriesData);
        
        // Probar vehículos
        try {
          const vehiclesData = await getVehicles();
          console.log('Vehículos:', vehiclesData);
          setVehicles(vehiclesData);
        } catch (vehicleError) {
          console.log('Error con vehículos (probablemente no autenticado):', vehicleError);
        }
        
      } catch (err) {
        console.error('Error:', err);
        setError(err instanceof Error ? err.message : 'Error desconocido');
      } finally {
        setLoading(false);
      }
    };

    testAPI();
  }, []);

  if (loading) {
    return (
      <div className="p-8">
        <h1 className="text-2xl font-bold mb-4">Probando APIs...</h1>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Prueba de APIs</h1>
      
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <h3 className="text-red-800 font-medium">Error:</h3>
          <p className="text-red-600">{error}</p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Servicios */}
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="text-lg font-semibold mb-2">Servicios ({services.length})</h2>
          <div className="space-y-2">
            {services.slice(0, 5).map((service) => (
              <div key={service.id} className="text-sm border-b pb-1">
                <div className="font-medium">{service.name}</div>
                <div className="text-gray-600">${service.price}</div>
              </div>
            ))}
            {services.length > 5 && (
              <div className="text-sm text-gray-500">... y {services.length - 5} más</div>
            )}
          </div>
        </div>

        {/* Categorías */}
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="text-lg font-semibold mb-2">Categorías ({categories.length})</h2>
          <div className="space-y-2">
            {categories.map((category) => (
              <div key={category.id} className="text-sm border-b pb-1">
                <div className="font-medium">{category.name}</div>
                <div className="text-gray-600">{category.description}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Vehículos */}
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="text-lg font-semibold mb-2">Vehículos ({vehicles.length})</h2>
          <div className="space-y-2">
            {vehicles.length === 0 ? (
              <div className="text-sm text-gray-500">
                No hay vehículos (probablemente no autenticado)
              </div>
            ) : (
              vehicles.map((vehicle) => (
                <div key={vehicle.id} className="text-sm border-b pb-1">
                  <div className="font-medium">{vehicle.brand} {vehicle.model}</div>
                  <div className="text-gray-600">{vehicle.plate}</div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPage;
